import * as React from 'react'
import { faExclamation, faTimes } from '@fortawesome/free-solid-svg-icons'
import { animated } from 'react-spring/web.cjs'

import { humanReadableBytes } from '@app/utils/file'

import FontAwesomeIcon from '@components/Icon/FontAwesomeIcon'

const errorMessages: { [key: string]: string } = {
  maxFiles: 'Please upload a maximum of %constraint file(s)',
  minFiles: 'Please ensure you are uploading at least %constraint file(s)',
  maxFileSize: 'exceeds the file size limit of %constraint',
  allowedMimeTypes: 'is not an accepted file type please upload %constraint',
}

const UploaderError = ({ style, error, constraints, cancelMap, refMap }: any) => {
  const getFileName = (error: Upload.DirectorConstraintError) => {
    const fileNameLength = error.fileName.length
    if (fileNameLength > 30) {
      return error.fileName.substring(0, 12) + '...' + error.fileName.substring(fileNameLength - 12)
    }
    return error.fileName
  }

  const getConstraintValue = (constraint: string): any => {
    switch (constraint) {
      case 'maxFileSize':
        return humanReadableBytes(constraints[constraint], true)
      default:
        return constraints[constraint]
    }
  }

  const getConstraintErrorMessage = (constraint: string) => {
    return errorMessages[constraint].replace('%constraint', getConstraintValue(constraint))
  }

  const handleErrorClose = (event: React.MouseEvent) => {
    event.stopPropagation()
    cancelMap.has(error) && cancelMap.get(error)()
  }

  return (
    <animated.div style={style}>
      <div className="uploader__error" ref={(ref) => ref && refMap.set(error, ref)} role="alert">
        <span className="uploader__error-icon">
          <FontAwesomeIcon icon={faExclamation} colour={'Error'} />
        </span>
        <span className="uploader__error-details">
          {error.fileName && `${getFileName(error)} `}
          {getConstraintErrorMessage(error.constraint)}
        </span>
        <button type="button" className="uploader__error-close" onClick={handleErrorClose}>
          <FontAwesomeIcon icon={faTimes} colour={'Muted'} size={'lg'} />
        </button>
      </div>
    </animated.div>
  )
}

export default UploaderError
